import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  className?: string;
  dot?: string;
}
export function Badge({
  children,
  className = '',
  dot
}: BadgeProps) {
  return <span className={`inline-flex items-center gap-1.5 rounded-md border px-2 py-0.5 text-xs font-medium leading-5 ${className || 'bg-slate-100 text-ink-muted border-line'}`} data-id="element-417" data-mp="14eh3a4b28wis">
      {dot && <span className={`h-1.5 w-1.5 rounded-full ${dot}`} data-id="element-418" data-mp="cn15rf7ytpds" />}
      {children}
    </span>;
}